import { useLazyQuery } from "@apollo/client";




































export const useDataClientLazyQuery = useLazyQuery;
